export {Ng2BreadcrumbModule} from './app/app.module';
export {BreadcrumbComponent} from './app/components/breadcrumb';
export {BreadcrumbService} from './app/components/breadcrumbService';


// WEBPACK FOOTER //
// ./~/ng2-breadcrumb/ng2-breadcrumb.ts